<template>
    <div class="left">
        <ul>
            <li class="nav-item" v-for="item,index in nav" :key="index">
                <router-link :to="item.path">{{ item.title }}</router-link>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'left',
    data () {
        return {
            nav: [
                {
                    title: '关于HTML',
                    path: '/home/html'
                },{
                    title: '关于CSS',
                    path: '/home/css'
                },{
                    title: '关于JS',
                    path: '/home/js'
                },{
                    title: '关于字体',
                    path: '/home/font'
                },{
                    title: '关于切图',
                    path: '/home/cut'
                },{
                    title: '整体框架',
                    path: '/home/framework'
                },{
                    title: '第三方插件',
                    path: '/home/plugins'
                },{
                    title: '关于Vue',
                    path: '/home/vue'
                },{
                    title: '关于项目',
                    path: '/home/project'
                },{
                    title: '其他',
                    path: '/home/other'
                }
            ]
        }
    }
}
</script>

<style lang="scss" scoped>
.left{
    position: sticky;
    left: 0;
    top: var(--header-height);
    width: 240px;
    flex-shrink: 0;
    padding: 50px 0;
    max-height: 100%;
    overflow: auto;
    z-index: 100;
    background-color: #fff;
    height: calc(100vh - var(--header-height));
    ul{
        list-style: none;
    }
    >ul{
        .nav-item{
            a{
                line-height: 40px;
                font-weight: 700;
                font-size: 16px;
                display: block;
                color: #333;
            }
        }
    }
}
</style>